import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  // WhatsApp number (remove spaces and special characters)
  const whatsappNumber = '919326255288';
  const whatsappMessage = encodeURIComponent('Hello! I am interested in your agricultural export products. Please provide more information.');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  useEffect(() => {
    // Show button after scrolling a bit
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Hide tooltip after 5 seconds
    const timer = setTimeout(() => {
      setShowTooltip(false);
    }, 5000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {/* Floating WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`fixed bottom-6 right-6 z-50 group transition-all duration-300 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-3 bg-white rounded-lg shadow-xl px-4 py-3 whitespace-nowrap animate-bounce">
            <div className="flex items-center space-x-2">
              <span className="text-sm font-semibold text-gray-800">Chat with us on WhatsApp!</span>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowTooltip(false);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X size={16} />
              </button>
            </div>
            <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
          </div>
        )}

        {/* Button */}
        <div className="relative">
          {/* Pulse animation ring */}
          <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
          
          {/* Main button with WhatsApp logo */}
          <div className="relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 group-hover:scale-110">
            {/* WhatsApp Logo SVG */}
            <svg 
              viewBox="0 0 32 32" 
              className="w-8 h-8 fill-current"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.293 1.416 1.412-5.245-0.298-0.511c-1.289-2.212-1.971-4.708-1.971-7.231 0-7.384 6.007-13.391 13.391-13.391s13.391 6.007 13.391 13.391c0 7.384-6.007 13.391-13.391 13.391z"/>
              <path d="M23.72 19.747c-0.352-0.176-2.081-1.027-2.404-1.145-0.323-0.118-0.558-0.176-0.793 0.176s-0.911 1.145-1.117 1.38c-0.206 0.235-0.411 0.264-0.763 0.088s-1.489-0.549-2.835-1.749c-1.048-0.934-1.756-2.087-1.962-2.439s-0.022-0.542 0.154-0.717c0.158-0.158 0.352-0.411 0.528-0.617s0.235-0.352 0.352-0.587c0.118-0.235 0.059-0.44-0.029-0.617s-0.793-1.906-1.086-2.611c-0.285-0.688-0.575-0.595-0.793-0.606-0.206-0.010-0.44-0.012-0.675-0.012s-0.617 0.088-0.94 0.44c-0.323 0.352-1.234 1.206-1.234 2.94s1.263 3.411 1.439 3.646c0.176 0.235 2.463 3.759 5.967 5.27 0.833 0.359 1.484 0.573 1.991 0.734 0.837 0.266 1.599 0.229 2.202 0.139 0.672-0.1 2.081-0.851 2.374-1.673s0.293-1.527 0.206-1.673c-0.088-0.147-0.323-0.235-0.675-0.411z"/>
            </svg>
          </div>

          {/* Online indicator */}
          <div className="absolute top-0 right-0 w-4 h-4 bg-green-400 border-2 border-white rounded-full"></div>
        </div>
      </a>
    </>
  );
};

export default WhatsAppButton;
